module.exports = __webpack_public_path__ + "img/Junior Suite.0d87c3b7.jpg";